import * as COST_API from '@/api/cost'

export default {
  state: {
    assembledPartCostEstimatorsList: {},
    partCost: {
      isLoading: false,
      loaded: false,
      list: [],
      current: null,
      currentVolumeId: null,
      currentScope: '',
      scopes: {},
      lineItems: {
        isLoading: false,
        saving: false,
        material: {
          finishLoading: false,
          list: [],
          current: null
        },
        labor: {
          finishLoading: false,
          list: [],
          current: null
        },
        fee: {
          finishLoading: false,
          list: [],
          current: null
        }
      },
      opChangeStates: {
        isSaving: false,
        isLoading: false,
        list: []
      }
    },
    activityDisplay: {
      isLoading: false,
      data: {}
    },
    stats: {
      pricingOverview: {
        list: [],
        isLoading: false
      }
    }
  },
  getters: {
    assembledPartCostEstimatorsList: state => state.assembledPartCostEstimatorsList,
    currentPartCost: (state) => {
      return state.partCost.list[state.partCost.current]
    },
    currentVolume: (state) => {
      if (state.partCost.current) {
        return state.partCost.list[state.partCost.current].volume
      }
    },
    currentPartCostScopeVolumes: (state) => {
      return state.partCost.scopes[state.partCost.currentScope]
    },
    hasPartCostLoaded: (state) => {
      return state.partCost.loaded
    },
    materialLineItems: (state) => {
      return state.partCost.lineItems.material.list
    },
    laborLineItems: (state) => {
      return state.partCost.lineItems.labor.list
    },
    feeLineItems: (state) => {
      return state.partCost.lineItems.fee.list
    },
    currentMaterialLineItem: (state) => {
      return _.find(state.partCost.lineItems.material.list, {
        id: state.partCost.lineItems.material.current
      })
    },
    isLineItemsLoading: (state) => {
      return state.partCost.lineItems.isLoading
    },
    isLineItemsSaving: (state) => {
      return state.partCost.lineItems.saving
    },
    isActivitiesDisplayLoading: (state) => {
      return state.activityDisplay.isLoading
    },
    activitiesDisplay: (state) => {
      return state.activityDisplay.data
    },
    hasfeeLineItemLoaded: (state) => {
      return state.partCost.lineItems.fee.finishLoading
    },
    haslaborLineItemLoaded: (state) => {
      return state.partCost.lineItems.labor.finishLoading
    },
    opChangeStatesOfPartCost: (state) => {
      return _.filter(state.partCost.opChangeStates.list, { part_cost_id: state.partCost.current })
    },
    opChangeStateSaving: (state) => {
      return state.partCost.opChangeStates.isSaving
    },
    opChangeStateLoading: (state) => {
      return state.partCost.opChangeStates.isLoading
    },
    costItemRecords: (state) => {
      return state.stats.pricingOverview.list
    }
  },
  mutations: {
    setAssembledPartCostEstimatorsList(state, payload) {
      state.assembledPartCostEstimatorsList = payload
    },
    addAssembledPartCostEstimator(state, payload) {
      state.assembledPartCostEstimatorsList.data.splice(0, payload)
    },
    removeAssembledPartCostEstimator(state, id) {
      const index = state.assembledPartCostEstimatorsList.data.findIndex(x => x.id === id)
      state.assembledPartCostEstimatorsList.data.splice(index, 1)
    },
    setIsLoading (state, { path, value }) {
      _.set(state, path, value)
    },
    setPartCost (state, data) {
      if (data && data.id) {
        if (state.partCost.list[data.id]) {
          state.partCost.list[data.id] = Object.assign({}, state.partCost.list[data.id], data)
        } else {
          state.partCost.list = Object.assign({}, state.partCost.list, { [data.id]: data })
        }
        state.partCost.current = data.id
      }
    },
    deletePartCost (state, id) {
      if (state.partCost.list[id]) {
        delete state.partCost.list[id]
      }
      state.partCost.current = null
    },
    setPartCostLoaded (state, value) {
      state.partCost.loaded = value
    },
    setCurrentVolume (state, volumeId) {
      state.partCost.currentVolumeId = volumeId
    },
    setScopeVolumes (state, { scope, value }) {
      state.partCost.scopes = Object.assign({}, state.partCost.scopes, { [scope]: value })
    },
    setCurrentScope (state, scope) {
      state.partCost.currentScope = scope
    },
    setLineItems (state, { type, data }) {
      _.set(state.partCost.lineItems, `${type}.list`, data)
    },
    setLineItem (state, { type, data }) {
      let index = null
      index = _.findIndex(state.partCost.lineItems[type].list, { id: data.id })
      if (index >= 0) {
        state.partCost.lineItems[type].list[index] = data
      } else {
        state.partCost.lineItems[type].list.push(data)
      }
    },
    setActivityDisplay (state, { path, value }) {
      _.set(state.activityDisplay, path, value)
    },
    setFinishLoading (state, { type, value }) {
      _.set(state.partCost.lineItems, `${type}.finishLoading`, value)
    },
    setLineItemsSaving (state, value) {
      state.partCost.lineItems.saving = value
    },
    setOpChangeStateSavingOrLoading (state, { action, value }) {
      if (action === 'save') {
        state.partCost.opChangeStates.isSaving = value
      } else {
        state.partCost.opChangeStates.isLoading = value
      }
    },
    setOpChangeStates (state, items) {
      let keyedById = _.map(items, (e) => {
        return { [e['id']]: e }
      })
      state.partCost.opChangeStates.list = Object.assign({}, state.partCost.opChangeStates.list, ...keyedById)
    },
    setStatsOfPricingOverviewSummaryItems (state, items) {
      state.stats.pricingOverview.list = items
    }
  },
  actions: {
    loadAssembledPartCostEstimators ({ commit }, params) {
      return COST_API.getAssembledPartCostEstimators(params).then(resp => {
        commit('setAssembledPartCostEstimatorsList', resp.data)
        return resp
      })
    },
    createAssembledPartCostEstimator ({ commit }, data) {
      return COST_API.createAssembledPartCostEstimator(data).then(resp => {
        commit('addAssembledPartCostEstimator', resp.data)
        return resp
      })
    },
    deleteAssembledPartCostEstimator ({ commit }, id) {
      return COST_API.deleteAssembledPartCostEstimator(id).then(resp => {
        commit('removeAssembledPartCostEstimator', id)
        return resp
      })
    },
    attachCostEstimatorToEntity ({ commit }, { id, data }) {
      return COST_API.attachCostEstimatorToEntity(id, data).then(resp => {
        return resp
      })
    },
    loadAssembledPartCosts ({ commit }, data) {
      return COST_API.getAssembledPartCosts(data).then(resp => {
        return resp.data
      })
    },
    deleteAssembledPartCost({ commit }, id) {
      return COST_API.deleteAssembledPartCost(id).then(resp => {
        commit('deletePartCost', id)
        commit('setPartCostLoaded', false)
        return resp.data
      })
    },
    loadAssembledPartCostById ({ commit }, id) {
      commit('setPartCostLoaded', false)
      COST_API.getAssembledPartCostById(id).then(resp => {
        commit('setPartCost', resp.data)
        commit('setPartCostLoaded', true)
        return resp.data
      })
    },
    createAssembledPartCost ({ commit }, data) {
      return COST_API.createAssembledPartCost(data).then(resp => {
        if (resp.data.id) {
          commit('setPartCost', Object.assign({}, { id: resp.data.id }, data))
        }
        return resp.data
      })
    },
    updateAssembledPartCost ({ commit }, { id, data }) {
      return COST_API.updateAssembledPartCost(id, data).then(resp => {
        if (resp.data) {
          commit('setPartCost', Object.assign({}, { id: id }, data))
        }
        return resp.data
      })
    },
    updateAssembledPartCostSetBom ({ commit }, { id, data }) {
      return COST_API.updateAssembledPartCostSetBom(id, data).then(resp => {
        return resp.data
      })
    },
    loadAssembledPartCostSummaries ({ commit }, id) {
      return COST_API.getAssembledPartCostSummaries(id).then(resp => {
        return resp.data
      })
    },
    initialAssembledPartCostMaterialCosts({ commit }, { id }) {
      return COST_API.initialAssembledPartCostMaterialCosts(id).then(resp => {
        return resp.data
      })
    },

    // Below is legency actions which partcost should have new action name as assembledPartCost
    loadPartCostByQuoteItem({ commit }, quoteItemId) {
      // commit('setPartCostLoaded', false)
      // return COST_API.getPartCostByQuoteItem(quoteItemId).then(resp => {
      //   commit('setPartCost', resp.data)
      //   commit('setPartCostLoaded', true)
      //   return resp
      // })
    },
    loadLineItems ({ commit }, { partCostId, lineItemType }) {
      commit('setIsLoading', { path: 'partCost.lineItems.isLoading', value: true })
      commit('setFinishLoading', { type: lineItemType, value: false })
      return COST_API.getLineItemsByType(partCostId, lineItemType).then(resp => {
        commit('setLineItems', { type: lineItemType, data: resp.data })
        commit('setIsLoading', { path: 'partCost.lineItems.isLoading', value: false })
        commit('setFinishLoading', { type: lineItemType, value: true })
        return resp.data
      })
    },
    saveMultipleLineItems ({ commit }, { partCostId, type, items, automaticPricing = true }) {
      return COST_API.saveMultipleLineItems(partCostId, type, items, automaticPricing).then(resp => {
        return resp.data
      })
    },
    setPartCostCurrentScope ({ commit }, scope) {
      commit('setCurrentScope', scope)
    },
    saveLineItem ({ commit }, data) {
      return COST_API.saveLineItem(data.part_cost_id, data.line_item_type, data).then(resp => {
        commit('setLineItem', { type: data.line_item_type, data: resp.data })
        return resp
      })
    },
    updateLineItem ({ commit }, { partCostId, id, data }) {
      return COST_API.updateLineItem(partCostId, id, data).then(resp => {
        commit('setLineItem', { type: data.line_item_type, data: resp.data })
        return resp
      })
    },
    updateMaterialsLineItem ({ commit }, { partCostId, id, data }) {
      return COST_API.updateMaterialsLineItem(partCostId, id, data).then(resp => {
        return resp
      })
    },
    deleteLineItem({ commit }, { partCostId, type, id }) {
      return COST_API.deleteLineItem(partCostId, type, id).then(resp => {
        return resp.data
      })
    },
    deleteLineItemList({ commit }, { partCostId, type }) {
      return COST_API.deleteLineItemList(partCostId, type).then(resp => {
        return resp.data
      })
    },
    loadActivityDisplay ({ state, commit }, domain) {
      commit('setIsLoading', { path: 'activityDisplay.isLoading', value: true })
      let path = 'data.' + domain
      let stored = _.get(state.cost, `activityDisplay.data.${path}`)
      return new Promise((resolve, reject) => {
        if (stored) {
          resolve(stored)
        } else {
          COST_API.getActivityDisplay(domain).then(resp => {
            commit('setActivityDisplay', { path: path, value: resp.data })
            commit('setIsLoading', { path: 'activityDisplay.isLoading', value: false })
            resolve(resp.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    createPartCostOpChangeState ({ commit }, { id, data }) {
      commit('setOpChangeStateSavingOrLoading', { action: 'save', value: true })
      COST_API.createPartCostOpChangeState(id, data).then(resp => {
        commit('setOpChangeStateSavingOrLoading', { action: 'save', value: false })
        commit('setOpChangeStates', [resp.data])
      })
    },
    loadPartCostOpChangeStates ({ commit }, { id, name = '' }) {
      commit('setOpChangeStateSavingOrLoading', { action: 'load', value: true })
      return COST_API.getPartCostOpChangeStates(id, name).then(resp => {
        commit('setOpChangeStateSavingOrLoading', { action: 'load', value: false })
        commit('setOpChangeStates', resp.data)
        return resp
      })
    },
    loadPricingOverviewSummary ({ commit }, scope) {
      return COST_API.getPricingOverviewSummary(scope).then(resp => {
        commit('setStatsOfPricingOverviewSummaryItems', resp.data)
        return resp
      })
    },
    generatePricingOverviewSummary ({ commit }, scope) {
      return COST_API.generatePricingOverviewSummary(scope).then(resp => {
        return resp
      })
    },
    createCostEstimateSubmit ({ commit }, { partCostId, scope, name, note }) {
      return COST_API.createCostEstimateSubmit(partCostId, scope, name, note).then(resp => {
        return resp
      })
    },
    loadCostEstimateSubmits ({ commit }, { partCostId, name }) {
      return COST_API.getCostEstimateSubmits(partCostId, name).then(resp => {
        return resp
      })
    },
    loadComponentPriceHistories ({ commit }, { mpn, brand }) {
      return COST_API.getComponentPriceHistories(mpn, brand).then(resp => {
        return resp
      })
    },
    callExtractComponentsPricesJob ({ commit }, data) {
      return COST_API.callExtractComponentsPricesJob(data).then(resp => {
        return resp
      })
    },
    getQuantityRelated ({ commit }, id) {
      return COST_API.getQuantityRelated(id).then(resp => {
        return resp
      })
    },
    getAllSuppliers ({ commit }, partIds = []) {
      return COST_API.getAllSuppliers(partIds).then(resp => {
        return resp
      })
    },
    loadModelParams ({ commmit }, costId) {
      return COST_API.loadModelParams(costId).then(resp => {
        return resp
      })
    },
    makePriceSuggestion({ commit }, { costId, data }) {
      return COST_API.makePriceSuggestion(costId, data).then(resp => {
        return resp
      })
    },
    getSCMAttributes ({ commit }, { componentType, id }) {
      return COST_API.getSCMAttributes(componentType, id).then(resp => {
        return resp
      })
    },
    getLastPurchase ({ commit }, { componentType, id }) {
      return COST_API.getLastPurchase(componentType, id).then(resp => {
        return resp
      })
    },
    getPriceTable ({ commit }, { costId, lineItemId }) {
      return COST_API.getPriceTable(costId, lineItemId).then(resp => {
        return resp
      })
    },
    getMaterialLineItemChangeLog ({ commit }, { costId, lineItemId }) {
      return COST_API.getMaterialLineItemChangeLog(costId, 'material', lineItemId).then(resp => {
        return resp
      })
    },
    getStdCost ({ commit }, id) {
      return COST_API.getStdCost(id).then(resp => {
        return resp
      })
    },
    checkBomScrapIntegrity({ commit }, { bomId, version }) {
      return COST_API.checkBomScrapIntegrity(bomId, version).then(resp => {
        return resp
      })
    },
    getCostedBOMParts ({ commit }, costEstimatorId) {
      return COST_API.getCostedBOMParts(costEstimatorId).then(resp => {
        return resp
      })
    },
    getCostedBOMReport ({ commit }, { costEstimatorId, reports, assembled_part_cost_id = null }) {
      return COST_API.getCostedBOMReport(costEstimatorId, reports, assembled_part_cost_id).then(resp => {
        return resp
      })
    },
    getCostEstimatorInfo ({ commit }, costEstimatorId) {
      return COST_API.getCostEstimatorInfo(costEstimatorId).then(resp => {
        return resp
      })
    },
    getCostedBomSummary({ commit }, costEstimatorId) {
      return COST_API.getCostedBomSummary(costEstimatorId).then(resp => {
        return resp
      })
    },
    // getPartCostsReport({ commit }, { costId, reports, assembled_part_cost_id }) {
    //   return COST_API.getPartCostsReport(costId, reports, assembled_part_cost_id).then(resp => {
    //     return resp
    //   })
    // },
    getPartCostsParts({ commit }, costId) {
      return COST_API.getPartCostsParts(costId).then(resp => {
        return resp
      })
    },
    getModifyPriceReasons({ commit }) {
      return COST_API.getModifyPriceReasons().then(resp => {
        return resp
      })
    },
    addSupplierQuote({ commit }, { costId, lineItemId, data }) {
      return COST_API.addSupplierQuote(costId, lineItemId, data).then(resp => {
        return resp
      })
    }
  }
}
